import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { AvEmptyStateComponent } from '../../../../Shared/Components/av-empty-state/av-empty-state.component';
import { AvPaginatorComponent } from '../../../../Shared/Components/av-paginator/av-paginator.component';
import { AvStatusChipComponent } from '../../../../Shared/Components/av-status-chip/av-status-chip.component';
import { PlanDetailFacade } from '../../../../../Facades/Plans/plan-detail.facade';
import { DATE_FORMAT, VALUE_UNRESOLVED } from '../../../../../Consts/backoffice.const';
import { PlanSubscriber } from '../../../../../Models/backoffice/plan-subscriber.model';

@Component({
  selector: 'av-plan-subscribers',
  standalone: true,
  imports: [
    DatePipe,
    DecimalPipe,
    MatIconModule,
    TranslateModule,
    AvEmptyStateComponent,
    AvPaginatorComponent,
    AvStatusChipComponent,
  ],
  templateUrl: './plan-subscribers.component.html',
  styleUrl: './plan-subscribers.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'd-block' },
})
export class PlanSubscribersComponent {
  private readonly _router = inject(Router);

  readonly facade = inject(PlanDetailFacade);

  readonly dateFormat = DATE_FORMAT;
  readonly unresolved = VALUE_UNRESOLVED;

  readonly isEmpty = computed<boolean>(
    () => this.facade.subscribersState() === 'ready' && this.facade.subscribers().length === 0,
  );

  goToPage(page: number): void {
    this.facade.goToSubscriberPage(page);
  }

  changePageSize(pageSize: number): void {
    this.facade.changePageSize(pageSize);
  }

  openOrganization(subscriber: PlanSubscriber): void {
    if (!subscriber.organization_id) {
      return;
    }

    this._router.navigate(['/organizations', subscriber.organization_id]);
  }
}
